import React from "react";
import "./benefitsSection.css";
import benefitIcon1 from "../../images/benefit-icon-1.svg";
import benefitIcon2 from "../../images/benefit-icon-2.svg";
import benefitIcon3 from "../../images/benefit-icon-3.svg";
import benefitIcon4 from "../../images/benefit-icon-4.svg";
import benefitIcon5 from "../../images/benefit-icon-5.svg";
import ScrollReveal from "../scrollReveal/scrollReveal";

export default function BenefitsSection() {
  const BenefitCard = ({ title, description, icon }) => {
    return (
      <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 benefits-card">
        <div className="benefits-card-inner">
          <div className="benefits-icon">
            <img src={icon} alt="benefits-icon" />
          </div>
          <div className="benefits-text">
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <ScrollReveal>
      <section className="solution-section benefits-section" id="one">
        <div className="container">
          <div className="benefits-section-wrapper">
            <div className="section-heading">
              <div className="heading-tag">
                <span>BENEFITS</span>
              </div>
              <div className="heading-description">
                <div>
                  <h2>Secure Your AI Systems with Assurance Systems</h2>
                </div>
                <p>
                  Experience the transformative benefits of AI assurance through
                  robust guardrails, superior quality assurance and proactive
                  risk management.
                </p>
              </div>
            </div>
            <div className="benefits-cards-wrapper row">
              <BenefitCard
                title="Earn Customer Trust Faster "
                description="Strengthen customer confidence with transparent, secure, and accountable AI solutions. "
                icon={benefitIcon1}
              />
              <BenefitCard
                title="Stay Ahead of Risks"
                description="Identify and mitigate potential risks proactively to ensure seamless AI performance. "
                icon={benefitIcon2}
              />
              <BenefitCard
                title="Fair Decisions, Every Time "
                description="Eliminate biases in AI processes with advanced detection and prevention tools. "
                icon={benefitIcon3}
              />
              <BenefitCard
                title="Streamlined Compliance Made Easy "
                description="Automated audits and regulatory checks, significantly reducing compliance costs. "
                icon={benefitIcon4}
              />
              <BenefitCard
                title="Unshakeable AI Reliability "
                description="Boost trust and consistency in AI systems with real-time trust scoring. "
                icon={benefitIcon5}
              />
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}
